import gsap from "gsap";
import EventDispatcher from "../../common/EventDispatcher";
import { Global } from "../../common/global";
import { getLeader } from "../../common/api";

export default class Leader {
  constructor() {
    document
      .querySelector("#leader_sec #leaderBack")
      .addEventListener("click", this.goBack.bind(this));
    for (let i = 1; i <= 1; i++) {
      document
        .querySelector(`#leader_sec .weeks #week${i}`)
        .addEventListener(
          "click",
          this.fetchAndDisplayLeaderData.bind(this, i)
        );
    }
  }
  init() {
    this.events = EventDispatcher.getObj();
    this.events.addEventListener("GAMESCENE_EVENTS", this.onEvents.bind(this));
  }
  onEvents(data) {
    switch (data["message"]["event_type"]) {
      case "show_screen":
        this.showScreen(data["message"]["data"]);
        break;
    }
  }
  showScreen(data) {
    if (data["screenKey"] !== "Leaderboard") return false;

    document.querySelector("#leader_sec").classList.add("active");

    this.fetchAndDisplayLeaderData(1);
  }
  async fetchAndDisplayLeaderData(week) {
    for (let i = 1; i <= 1; i++) {
      document
        .querySelector(`#leader_sec .weeks #week${i}`)
        .classList.remove("active");
    }
    document
      .querySelector(`#leader_sec .weeks #week${week}`)
      .classList.add("active");
    document.querySelector("#leader_sec .leader_content").innerHTML = "";

    document.querySelector("#loader").classList.add("active");
    const result = await getLeader(week);
    document.querySelector("#loader").classList.remove("active");

    result.data.forEach((data, index) => {
      if (index <= 1) {
        document.querySelector("#leader_sec .leader_content").innerHTML += `
                <div class="leader"><div class="rank_icon"><img src="./ui/Leaderboad-${
                  index + 1
                }.png" alt="" srcset=""></div><div class="rank">#${
          index + 1
        }</div><div class="mobile">${
          data.mobile
        }</div><div class="score"><div class="icon"><img src="./ui/Leaderboad-Goal.png" alt="" srcset=""></div><div class="info">${
          data.score
        }</div></div></div>
                `;
      } else {
        document.querySelector("#leader_sec .leader_content").innerHTML += `
                <div class="leader"><div class="rank_icon"></div><div class="rank">#${
                  index + 1
                }</div><div class="mobile">${
          data.mobile
        }</div><div class="score"><div class="icon"><img src="./ui/Leaderboad-Goal.png" alt="" srcset=""></div><div class="info">${
          data.score
        }</div></div></div>
                `;
      }
    });
    if (result.userData) {
      document.querySelector(".self.leader").classList.add("active");
      document.querySelector(
        ".self.leader .rank"
      ).innerHTML = `#${result.userData.rank}`;
      document.querySelector(
        ".self.leader .mobile"
      ).innerHTML = `#${result.userData.mobile}`;
      document.querySelector(
        ".self.leader .score .info"
      ).innerHTML = `${result.userData.score}`;
    } else {
      document.querySelector(".self.leader").classList.remove("active");
    }
  }
  goBack() {
    this.hideScreen();
    this.events.dispatchEvent({
      type: "GAMESCENE_EVENTS",
      message: {
        event_type: "show_screen",
        data: {
          screenKey: Global.goBackTo,
        },
      },
    });
  }
  hideScreen() {
    document.querySelector("#leader_sec").classList.remove("active");
  }
}
